<template>
  <div id="app">
    <navbar :key="$route.fullPath" />
    <div class="container">
      <router-view/>
      <loader />
    </div>
  </div>
</template>

<script>
import navbar from './components/layouts/navbar'
import loader from './components/layouts/loader'
export default {
  name: 'app',
  components:{
    navbar,
    loader
  }
}
</script>
